export type {
  NumberRange,
  LightReport,
  PushAllResponse,
  StringNumberRange,
  SpeedLevel,
  ExternalTray,
  AMSTray,
  AMS,
  StringBoolean,
  StringNumber,
  PrintStage,
  PrintStageInfo,
  EnrichedStageInfo,
  PrintStageDetails,
  FilamentType,
  getStageFromCurr,
  getStagesFromArray,
  getEnrichedStages,
  stageCurrToStage,
} from "./printerResponse";

// Re-export BambuClientPrinterStatus from bambu-node for now (need to check if this needs to be moved)
export type BambuClientPrinterStatus = "FINISH" | "FAILED" | "RUNNING" | "IDLE" | "PAUSE" | "PREPARE" | "SLICING" | "OFFLINE";

export enum PrinterModelNamesShort {
  X1C = "X1C",
  X1 = "X1",
  X1E = "X1E",
  P1P = "P1P",
  P1S = "P1S",
  A1 = "A1",
  A1M = "A1M",
  H2D = "H2D",
}

export enum PrinterModelIDs {
  X1C = "BL-P001",
  X1 = "BL-P002",
  P1P = "C11",
  P1S = "C12",
  X1E = "C13",
  A1 = "N2S",
  A1M = "N1",
  H2D = "O1D"
}

/**
 * Mapping of printer model IDs to their friendly model names
 * This includes:
 * - Official model IDs from machine profiles (BL-P001, C11, etc.)
 * - Full names (from project_settings.config)
 */
export const PRINTER_MODEL_MAP: Record<PrinterModelIDs, string> = {
  // Official model IDs from machine profiles
  [PrinterModelIDs.X1C]: "X1C", // X1 Carbon
  [PrinterModelIDs.X1]: "X1", // X1
  [PrinterModelIDs.P1P]: "P1P", // P1P
  [PrinterModelIDs.P1S]: "P1S", // P1S
  [PrinterModelIDs.X1E]: "X1E", // X1E
  [PrinterModelIDs.A1]: "A1", // A1
  [PrinterModelIDs.A1M]: "A1M", // A1 Mini
  [PrinterModelIDs.H2D]: "H2D", // H2D
};

/**
 * Mapping of printer model IDs to their full names
 * This includes:
 * - Official model IDs from machine profiles (BL-P001, C11, etc.)
 * - Full names (from project_settings.config)
 */
export const PRINTER_MODEL_LONG_NAME_MAP: Record<
  PrinterModelIDs,
  PrinterLongNames
> = {
  // Full names (for project_settings.config)
  [PrinterModelIDs.X1C]: "Bambu Lab X1C",
  [PrinterModelIDs.X1]: "Bambu Lab X1",
  [PrinterModelIDs.P1S]: "Bambu Lab P1S",
  [PrinterModelIDs.P1P]: "Bambu Lab P1P",
  [PrinterModelIDs.A1]: "Bambu Lab A1",
  [PrinterModelIDs.A1M]: "Bambu Lab A1 Mini",
  [PrinterModelIDs.X1E]: "Bambu Lab X1C",
  [PrinterModelIDs.H2D]: "Bambu Lab H2D", // H2D
};

export const CONNECT_RETURN_CODE_DESC = {
  0: "Connection successful",
  1: "Connection refused - incorrect protocol version",
  2: "Connection refused - invalid client identifier",
  3: "Connection refused - server unavailable",
  4: "Connection refused - bad username or password",
  5: "Connection refused - not authorised",
};

export type PrinterLongNames =
  | "Bambu Lab X1C"
  | "Bambu Lab X1"
  | "Bambu Lab P1S"
  | "Bambu Lab P1P"
  | "Bambu Lab A1"
  | "Bambu Lab A1 Mini"
  | "Bambu Lab H2D";

export type AMS_PREFIX = "A" | "B" | "C" | "D";

export const AMS_LETTER_MAP: Record<string, AMS_PREFIX> = {
  "0": "A",
  "1": "B",
  "2": "C",
  "3": "D",
};
